import React from 'react';
import { useAuth } from '../AuthContext';
import { ADDRESS, PARK_PHONE, mapsUrl } from '../campsite';
import { formatPhone } from '../phone';


const figureStyle: React.CSSProperties = {
  margin: '0 0 1.5rem 0',
};

const imageStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: '600px',
  height: 'auto',
  borderRadius: '8px',
  display: 'block',
};

const captionStyle: React.CSSProperties = {
  fontSize: '0.9rem',
  fontStyle: 'italic',
  opacity: 0.8,
  marginTop: '0.5rem',
};

function Location(): JSX.Element {
  const { username } = useAuth();

  // Signed-out visitors only see the general area, not the exact site.
  if (!username) {
    return (
      <div className="card">
        <h2>📍 Campsite Location</h2>
        <p><strong>Area:</strong> Near Chattanooga, TN</p>
        <p>
          The exact campground, site number, and directions are shared with registered
          attendees. Use the Login tab to sign in and see the full details.
        </p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2>📍 Campsite Location</h2>
      <p><strong>Campsite Name:</strong> Hiwassee Scenic River State Park — Gee Creek Campground</p>
      <p><strong>Site:</strong> Group Site 6 (G6)</p>
      <p>
        <strong>Address:</strong>{' '}
        <a href={mapsUrl()} target="_blank" rel="noopener noreferrer">
          {ADDRESS}
        </a>
      </p>
      <p>
        <strong>Park Office:</strong>{' '}
        <a href={`tel:${PARK_PHONE}`}>{formatPhone(PARK_PHONE)}</a>
      </p>
      <p>
        <a
          href="https://tnstateparks.com/parks/hiwassee-river"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#8e98f7', textDecoration: 'none' }}
        >
          Visit the park website
        </a>
      </p>

      <h3>🗺️ Campground Map</h3>
      <figure style={figureStyle}>
        <img
          src="/gee-creek-map.png"
          alt="Map of Gee Creek Campground with Group Site 6 highlighted on the west side near the amphitheater"
          style={imageStyle}
        />
        <figcaption style={captionStyle}>
          Group Site 6 (G6) is on the west side of the campground, near the amphitheater
          and the nature trail along the Hiwassee River.
        </figcaption>
      </figure>

      <h3>🏕️ Our Site</h3>
      <figure style={figureStyle}>
        <img
          src="/group-site-6.jpg"
          alt="Photo of Group Site 6: an open grassy clearing with picnic tables, bordered by trees"
          style={imageStyle}
        />
        <figcaption style={captionStyle}>
          Group Site 6 — a large open grassy area with picnic tables, backed by woods.
        </figcaption>
      </figure>
    </div>
  );
}

export default Location;
